<app-menu [moduloEnum]="moduloEnum" [funcionalidadeEnum]="funcionalidadeEnum"></app-menu>

<div class="container">
    <div class="row">
        <div class="col-12 col-md-4">
            <h1 class="title-default">Logs</h1>
        </div>
        <div class="col-12 col-md-8">
            <mat-slide-toggle [(ngModel)]="this.modoPainel" (change)="changeMode($event)">Modo
                Painel</mat-slide-toggle>
        </div>
    </div> 
    <form class="form" [formGroup]="model"  (ngSubmit)="clickPesquisar()" class="search-area">
        <div class="row">
            <div class="col-12 col-sm-6 col-md-3">
                <mat-form-field appearance="outline">
                    <mat-label>ID LOG</mat-label>
                    <input matInput formControlName="idLog" type="text" (keypress)="somenteNumeros($event)">
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
                <mat-form-field appearance="outline">
                    <mat-label>Pesquisar</mat-label>
                    <input matInput formControlName="textoBusca" type="text">
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
                <app-select-pesquisavel
                    label="Empresas"
                    [control]="listIdEmpresaControl"
                    [apiUrl]="_urlListEmpresa"
                    [idField]="'idEmpresa'"
                    [nameField]="'nomeEmpresa'"
                    [isOptional]="true"
                    [multiple]="true"
                    [preloadedOptions]="preloadedEmpresa">
                </app-select-pesquisavel>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
                <mat-form-field appearance="outline">
                    <mat-label>Tipo</mat-label> 
                    <mat-select  formControlName="tipo">
                        <mat-option [value]="'E'">Erro</mat-option>
                        <mat-option [value]="'S'">Sucesso</mat-option>
                        <mat-option [value]="'W'">Aviso</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
                <button type="submit" mat-button class="btn-secundary" style="width: 140px;">
                    Pesquisar
                </button>
            </div>
        </div>
    </form>

    @if(this._listaLogResponse && this._listaLogResponse.listaLogStruct.length > 0){
        @if(!this.modoPainel){
            <table mat-table [dataSource]="_dataSource">
                <ng-container matColumnDef="idLog">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> # </th>
                  <td mat-cell *matCellDef="let element"> {{element.idLog}} </td>
                </ng-container>
            
                <ng-container matColumnDef="idEmpresa" class="w-25">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-responsiva"> Nome empresa </th>
                  <td mat-cell *matCellDef="let element"  class="col-responsiva"> {{buscarNomeEmpresa(element.idEmpresa)}} </td>
                </ng-container>
            
                <ng-container matColumnDef="tipo">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Tipo </th>
                  <td mat-cell *matCellDef="let element"> <app-chip-status [status]="element.tipo"></app-chip-status></td>
                </ng-container>
            
                <ng-container matColumnDef="projetoOrigem">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-responsiva"> Projeto </th>
                  <td mat-cell *matCellDef="let element" class="col-responsiva"> {{element.projetoOrigem}} </td>
                </ng-container>
            
                <ng-container matColumnDef="funcaoOrigem">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-responsiva"> Função </th>
                  <td mat-cell *matCellDef="let element" class="col-responsiva"> {{element.funcaoOrigem}} </td>
                </ng-container>
            
                <ng-container matColumnDef="datetimeInclusao">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-responsiva"> Data </th>
                  <td mat-cell *matCellDef="let element" class="col-responsiva"> {{element.datetimeInclusao | date:'dd/MM/yyyy HH:mm:ss'}} </td>
                </ng-container>
            
                <ng-container matColumnDef="action-edit">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                  <td mat-cell *matCellDef="let element"> 
                    <a mat-mini-fab class="fab-action default" [routerLink]="['/desenvolvedor/logs/detalhe', {idLog: element.idLog}]">
                      <mat-icon>visibility</mat-icon>
                    </a>
                  </td>
                </ng-container>
            
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        } @else {
            <!-- Painel -->
             <div class="painel-logs-content">
                @for (log of _dataSource.data; track $index) {
                    <div class="card-log">
                        <div class="logs-header">
                            <p>#{{log.idLog}}</p>
                            <p>{{log.datetimeInclusao | date:'dd/MM/yyyy HH:mm:ss'}}</p>
                        </div>
    
                        <div class="informacoes">
                            <p>Empresa: {{buscarNomeEmpresa(log.idEmpresa)}}</p>
    
                            <div>
                                <p>Projeto:</p>
                                <p class="background-grey">{{log.projetoOrigem}}</p>
                            </div>
    
                            <div>
                                <p>Função:</p>
                                <p class="background-grey funcao">{{log.projetoOrigem}}</p>
                            </div>
                        </div>
    
                        <div class="logs-footer">
                            <app-chip-status [status]="log.tipo"></app-chip-status>
    
                            <a mat-mini-fab aria-label="Editar" class="fab-action default" [routerLink]="['/desenvolvedor/logs/detalhe', {idLog: log.idLog}]">
                                <mat-icon>visibility</mat-icon>
                            </a>
                        </div>
                    </div>
                }
             </div>
        }
        <div class="col-12 text-center ver-mais-pesquisa">
            <button type="button" mat-button class="btn-primary" [disabled]="_ultimaPagina" (click)="proximaPagina()">
                @if (_isLoading === true) {
                    <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                }
                @else{
                    <span class="material-symbols-outlined">keyboard_arrow_down</span>
                    Ver mais
                }
            </button>
        </div>
    }@else if(this._isLoading === true){
        @if(!this.modoPainel){
            <table>
                @for (item of [1,2,3]; track item) {
                    <tr>
                        <td>
                            <app-loading-box [height]="'23'" [width]="'110'" [marginTop]="'30'"></app-loading-box>
                        </td>
                        <td>
                            <app-loading-box [height]="'23'" [width]="'220'" [marginTop]="'30'" [marginLeft]="'50'"></app-loading-box>
                        </td>
                        <td>
                            <app-loading-box [height]="'23'" [width]="'320'" [marginTop]="'30'"  [marginLeft]="'50'"></app-loading-box>
                        </td>
                        <td>
                            <app-loading-box [height]="'23'" [width]="'40'" [marginTop]="'30'"  [marginLeft]="'100'"></app-loading-box>
                        </td>
                        <td>
                            <app-loading-box [height]="'23'" [width]="'40'" [marginTop]="'30'"  [marginLeft]="'20'"></app-loading-box>
                        </td>
                    </tr>
                }
            </table>
        } @else {
            <div class="painel-logs-content">
                @for (item of [1,2,3]; track item) {
                    <div class="card-log">
                        <div class="logs-header">
                            <app-loading-box [height]="'23'" [width]="'240'" [marginTop]="'30'"></app-loading-box>
                        </div>
        
                        <div class="informacoes">
                            <app-loading-box [height]="'23'" [width]="'100%'" [marginTop]="'30'"></app-loading-box>
        
                            <div>
                                <app-loading-box [height]="'46'" [width]="'100%'" [marginTop]="'30'"></app-loading-box>
                            </div>
        
                            <div>
                                <app-loading-box [height]="'96'" [width]="'100%'" [marginTop]="'30'"></app-loading-box>
                            </div>
                        </div>
        
                        <div class="logs-footer">
                            <app-loading-box [height]="'23'" [width]="'240'" [marginTop]="'30'"></app-loading-box>
                        </div>
                    </div>
                }
            </div>
        }
    }
    @else if(this._listaLogResponse?.listaLogStruct?.length === 0){
        <app-empty-list [title]="'Não foi encontrado nenhum log com o filtro informado'"></app-empty-list>
    }
    

    
</div>
